import React, { Component } from "react";
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import LectureDashboardSection from "../components/home/LectureDashboardSection";
import * as Cookies from "es-cookie";
import { withRouter, Redirect } from "react-router-dom";
import { isBrowser } from "react-device-detect";
import { isLecturerRole } from "../../moduleAccessGuard";

class LectureDashboard extends Component {
  menuToggler = () => {
    const toggled = Cookies.get("toggle");
    if (toggled === "wrapper") {
      this.setState({ toggled: "wrapper sidebar-enable" });
      Cookies.set("toggle", "wrapper sidebar-enable");
    } else {
      this.setState({ toggled: "wrapper" });
      Cookies.set("toggle", "wrapper");
    }
  };

  render() {
    if (Cookies.get("token") == undefined) return <Redirect to="/login" />;

    if (!isLecturerRole()) {
      return <Redirect to="/dashboard" />;
    }

    return (
      <div className={Cookies.get("toggle") || "wrapper"}>
        <div className="header-area">
          <NavbarOne onClick={() => this.menuToggler()} />
        </div>
        <div className="main-wrapper">
          <div
            id="sidebar"
            className={
              isBrowser == true
                ? "sidebar-menu d-none d-xl-block d-lg-block"
                : "sidebar-menu d-block d-xl-none d-lg-none"
            }
          >
            <SideNavbar onClick={() => this.menuToggler()} />
          </div>
          <div className="student-overlay" onClick={() => this.menuToggler()} />
          <div className="content-wrapper pt-0">
            <LectureDashboardSection />
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(LectureDashboard);
